<div *ngIf="this.isLoading" class="se-loader"></div>
<div class="grid-div mb-3 hide-in-mobile">
  <div class="left-div">
    <div class="txt_label mr-14 rsdata">
      {{labels.select | translate}} {{labels.resourceData | translate}}
    </div>
    <button class="se-button button-primary btn-getData" *ngIf="latestTelemetryData" (click)="Get_TimeseriesData()"
            [ngClass]="{isDisabled : notChanged || selectedResources.length == 0}">
      {{labels.getData | translate}}
    </button>
  </div>
  <div class="right-div">
    <ul>
      <li class="a1">
        <span class="txt_label mr-10 ml-3">{{labels.viewData | translate}}:</span>
        <button class="se-button btn-grp" (click)="GetTelemetryData_day()" [ngClass]="{selected: isDay , 'isDisabled':!noDataG && !(telemetryData.length>0)}">{{labels.last24hr | translate}}</button>
        <button class="se-button btn-grp" (click)="GetTelemetryData_week()" [ngClass]="{selected: isWeek , 'isDisabled':!noDataG && !(telemetryData.length>0)}">{{labels.week | translate}}</button>
        <button class="se-button btn-grp" (click)="GetTelemetryData_month()" [ngClass]="{selected: isMonth , 'isDisabled':!noDataG && !(telemetryData.length>0)}">{{labels.month | translate}}</button>
        <span class="calender txt_label">
          {{labels.until | translate}}
          <p-calendar id="pcalender" placeholder="DD/MM/YYYY" [ngClass]="{'isDisabled':!noDataG && !(telemetryData.length>0)}"
                      [(ngModel)]="selectedDate" appendTo="body" readonlyInput="true" dateFormat="dd-MM-yy" placeholder="Select Date"
                      showButtonBar="true" [showIcon]="true" (onSelect)="onSelect($event)">
          </p-calendar>

        </span>
        <a class="ml-2">
          <img class=" graph_icon" [ngClass]="{tbl_selected: chartogrid}"
               (click)="change_grid()"
               (keypress)="change_grid()"
               (keydown)="change_grid()"
               (keyup)="change_grid()" src="assets/bulleted-list.svg" alt="bulleted list" height="30" width="30"/>
          <img class="graph_icon" [ngClass]="{tbl_selected: !chartogrid}"
               (click)="change_graph()" (keypress)="change_graph()"
               (keydown)="change_graph()"
               (keyup)="change_graph()" src="assets/graph.svg" alt="graph" height="30" width="30"/>
        </a>
      </li>
    </ul>
  </div>
  <div>
    <div class="rectangle-grid-latest">
      <div *ngIf="!noData" class="load_div">
        <span *ngIf="!latestTelemetryData">
          {{labels.loadData | translate}}<em class="fa fa-spinner fa-pulse fa-2x fa-fw"></em>
        </span>
      </div>
      <div *ngIf="noData" class="nodata_block">
        <span *ngIf="!latestTelemetryData">{{labels.noData | translate}}</span>
      </div>
      <span *ngIf="latestTelemetryData" class="cls_note">{{labels.note | translate}}</span>
      <p-table #dt *ngIf="latestTelemetryData" [columns]="latestTelemetryGridcols" class="tbl-resources"
               name="teldata" ngDefaultControl [value]="latestTelemetryData" [paginator]="isPaginationL" [rows]="13">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" class="width025em">#</th>
            <th scope="col" *ngFor="let col of columns" class="wordWrap" [pSortableColumn]="col.field"
                [pSortableColumnDisabled]="col.field == 'unit'" [ngStyle]="{'width': col.width, 'display': col.display}">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field" *ngIf="col.field !== 'unit'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th scope="col" class="width16perc wordWrap">
              {{labels.select | translate}}
            </th>
            <th scope="col" class="width16perc wordWrap">{{labels.alarms | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr>
            <td>
              {{i+1}}
            </td>
            <td *ngFor="let col of columns" [ngStyle]="{'width': col.width, 'display': col.display}">
              <span *ngIf="col.field == 'timeStamp'" appendTo="target" class="relativePosition">
                {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm:ss':'+0000'}}
              </span>
              <span *ngIf="col.field != 'timeStamp'" appendTo="target" class="relativePosition">
                {{rowData[col.field]}}
              </span>
            </td>
            <td>
              <p-checkbox name="box{{i+1}}" class="chkbox_resource"
                          (onChange)="handleData($event)"
                          value="{{rowData[columns[1].field]}}" label="" [(ngModel)]="selectedResources">
              </p-checkbox>
            </td>
            <td>
              <img title="Edit Alarm" id="EdtAlrm{{i+1}}" *ngIf="rowData.alarmRuleId!=null" alt="alarms" width="15px" height="14px"
                   (click)="EditAlarms(rowData.alarmRuleId,rowData.unit,rowData.resourceName)" src="assets/bell-icon-fill.png"
                   (keypress)="EditAlarms(rowData.alarmRuleId,rowData.unit,rowData.resourceName)"
                   (keydown)="EditAlarms(rowData.alarmRuleId,rowData.unit,rowData.resourceName)"
                   (keyup)="EditAlarms(rowData.alarmRuleId,rowData.unit,rowData.resourceName)" />
              <img title="Add Alarm" id="AddAlrm{{i+1}}" (data-target)="0" *ngIf="rowData.alarmRuleId==null" alt="noAlarms" width="15px" height="14px"
                   (click)="AddAlarms(rowData, rowData.resourceName,rowData.unit,rowData.resourceId,i+1,$event)"
                   (keypress)="AddAlarms(rowData.resourceName,rowData.unit,rowData.resourceId,i+1,$event)"
                   (keydown)="AddAlarms(rowData.resourceName,rowData.unit,rowData.resourceId,i+1,$event)"
                   (keyup)="AddAlarms(rowData.resourceName,rowData.unit,rowData.resourceId,i+1,$event)" src="assets/bell-icon.png" />
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="rectangle-grid-detail">
      <div *ngIf="!noDataG && !(telemetryData.length>0)" class="teleDataLoader">
        <span>{{labels.loadTelemetryData | translate}}<em class="fa fa-spinner fa-pulse fa-2x fa-fw"></em></span>
      </div>
      <div *ngIf="noDataG" class="centerTextAlign">
        <span>{{labels.noData | translate}}</span>
      </div>
      <div *ngIf="telemetryData.length>0">
        <div *ngIf="!chartogrid" class="chart-wrapper">
          <div class="chart-inner">

            <div #ele1 [chart]="boolStock" class="boolStock"></div>

          </div>
        </div>
        <div *ngIf="chartogrid">
          <div class="caption">
            <span class="txt_label mr-10" title="{{labels.selectedResourceData | translate}}">{{labels.selectedResourceData | translate}}</span>
          </div>
          <p-table #dt [columns]="telemetryGridcols" [scrollable]="true" [value]="telemetryData" [paginator]="isPaginationD" [rows]="13"
                   frozenWidth="200px" name="telgrid" ngDefaultControl>

            <ng-template pTemplate="header" let-columns>
              <tr>
                <th scope="col">#</th>
                <th scope="col" *ngFor="let col of columns" class="resColumnPadding" [pSortableColumnDisabled]="col.field == 'value'" [pSortableColumn]="col.field">
                  {{col.header | translate}}
                  <p-sortIcon [field]="col.field" *ngIf="col.field == 'timeStamp'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
              <tr>
                <td>
                  {{i+1}}
                </td>
                <td *ngFor="let col of columns; let j=index">
                  <div *ngIf="col.field == 'timeStamp'">
                    <span appendTo="target" class="relativePosition">
                      {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm:ss':'+0000'}}
                    </span>
                  </div>
                  <ng-container *ngFor="let item of telemetryGridcols">
                    <span *ngIf="rowData.dataSeries[j-1] && item.header ==  rowData.dataSeries[j-1].resourceName && col.field != 'timeStamp' " appendTo="target" class="relativePosition">
                      {{ rowData.dataSeries[j-1].value == null ? '**' : rowData.dataSeries[j-1].value | precision }}
                    </span>
                  </ng-container>
                </td>


              </tr>
            </ng-template>
          </p-table>
          <button *ngIf="latestTelemetryData" class="se-button button-primary" (click)="ExportToExcel(telemetryData)"
                  [disabled]="!telemetryData.length"
                  [ngClass]="{isDisabled : enableExport || selectedResources.length == 0}"
                  [ngStyle]="{'cursor': telemetryData.length > 0 ? 'pointer' : 'no-drop' }">
            {{labels.btnExport | translate}}
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="hide-in-large">
  <div class="top-div">
    <div class="filter-sec">
      <input #filtr type="text" aria-label="search" [(ngModel)]="targetSearch"
             class="input-globalsearch" size="50" placeholder={{labels.search|translate}}>
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
    </div>
  </div>
  <div class="row mobile-resource-list">
    <div class="card-mobile support-card" *ngFor="let data of latestTelemetryData  | filterBy: targetSearch">
      <div *ngFor="let col of latestTelemetryGridcols" [ngStyle]="{ 'display': col.display}">
        <div class="row data-row">
          <div class="col card-col">
            <p class="mobile-grid-header">{{col.header|translate}}</p>
            <p class="mobile-grid-data mobile-grid-width datefeild-width relativePosition" *ngIf="col.field == 'timeStamp'" appendTo="target">
              {{data[col.field] | date : 'dd-MM-yyyy HH:mm:ss':'+0000'}}
            </p>
            <p class="mobile-grid-data mobile-grid-width relativePosition" *ngIf="col.field != 'timeStamp'" appendTo="target">
              {{data[col.field]}}
            </p>
          </div>
        </div>
      </div>

      <div class="row data-row">
        <div class="col card-col">
          <p class="mobile-grid-header mobile-grid-width">
          </p>
        </div>
      </div>

      <div class="row data-row float-right">
        <div class="col card-col datefeild-width">
          <button class="mobile-grid-data se-button button-primary float-right" (click)="getSingleResourceDayTelmetryData(data['resourceName'])">
            {{labels.getData | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>

<div class="se-dialog full-page-dialog" #resourceContent *ngIf="showResourceData">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{selResourceData}} {{labels.resourceData | translate}}</h3>
      <div class="float-right">
        <span class="se-font-color" (click)="closeModal()"
              (keypress)="closeModal()"
              (keydown)="closeModal()"
              (keyup)="closeModal()">
          {{labels.close | translate}}
        </span>
      </div>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="dialog-top-div">
        <div class="filter-sec">
          <input #dialogFiltr type="text" aria-label="search" [(ngModel)]="dialogTargetSearch"
                 class="input-globalsearch" size="50" placeholder={{labels.search|translate}}>
          <a class="SearchLink">
            <em class="fa fa-search SearchIcon"></em>
          </a>
        </div>
      </div>
      <div class="resource-detail-list">
        <div class=" card-mobile support-card" *ngIf="singleResourceDayDataNotExists">
          <div class="row data-row">
            <div class="col card-col noData">
              {{labels.noRecords | translate}}
            </div>
          </div>
        </div>
        <div *ngIf="!singleResourceDayDataNotExists" class="p-1">
          <div class="dialog-card-mobile dialog-support-card" *ngFor="let data of singleResourceDayData  | filterBy: dialogTargetSearch">
            <div *ngFor="let col of resourcecols">
              <div class="row data-row">
                <div class="col card-col">
                  <p class="mobile-grid-header" *ngIf="col.field == 'timeStamp'">{{col.header|translate}}</p>
                  <p class="mobile-grid-header" *ngIf="col.field == 'value'">{{selResourceData}} {{col.header|translate}}</p>
                  <p class="mobile-grid-data mobile-grid-width datefeild-width relativePosition" *ngIf="col.field == 'timeStamp'" appendTo="target">
                    {{data[0] | date : 'dd-MM-yyyy HH:mm:ss':'+0000'}}
                  </p>
                  <p class="mobile-grid-data mobile-grid-width relativePosition" *ngIf="col.field != 'timeStamp'" appendTo="target">
                    {{data[1]}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="showAlarmModal">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header flexDisplay">
      <h3 class="se-dialiog-title col">{{contentHeader | translate}}</h3>
      <span class="text-right col">
        <img src="assets/close.svg" class="icon-action whiteColor" (click)="closeModal()" (keypress)="closeModal()"
             (keydown)="closeModal()"
             (keyup)="closeModal()" alt="close" height="29" width="29"/>
      </span>
    </div>
    <div class="se-dialog-body" >
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="se-inline-form AlarmModel">
        <!-- alarm name -->
        <div class="form-ele col-md-12">
          <label for="txtAlarmName" class="se-label col-md-3">{{labels.alarmName | translate}}<span>*</span></label>
          <input id="txtAlarmName" placeholder="{{labels.alarmName | translate}}" type="text" autocomplete="off"
                 class="se-form-control col-md-9 commonWidth" [(ngModel)]="alarmRuleName" #txtAlarmName appRequiredElementValidator #alarmName="ngModel" [fieldName]="'Alarm Name'"
                 [minLength]="1" [maxLength]="500" (keyup)="validateForm()">
          <div class="d-block brand-error se-fs-12" *ngIf="!alarmName.errors.requiredElementValidator.isValid && (alarmName.dirty || alarmName.touched)">
            {{ alarmName.errors.requiredElementValidator.error }}
          </div>
        </div>

        <div class="form-ele col-md-12">
          <label class="se-label col-md-3"> {{labels.tableHeaderDongleUId | translate}}</label>
          <label class="se-form-control col-md-9 ml0 commonWidth"> {{selectedDongleUId}}</label>
        </div>
        <!-- controller -->
        <div class="form-ele col-md-12">
          <label class="se-label col-md-3"> {{labels.controller | translate}}</label>
          <label class="se-form-control col-md-9 ml0 commonWidth"> {{selectedContrl}}</label>
        </div>
        <!-- resources by controller -->
        <div class="form-ele col-md-12">
          <label class="se-label col-md-3"> {{labels.resource | translate}}</label>
          <label class="se-form-control col-md-9 ml0 commonWidth"> {{selectedRes}}</label>
        </div>
        <div class="form-ele" *ngIf="!showAlarmWhen">
          <!-- min res value -->
          <div class="form-ele col-md-12">
            <label for="minVal" class="se-label col-md-3"> {{labels.limit| translate}} ({{labels.min| translate}})<span>*</span></label>
            <input id="minVal" type="number" autocomplete="off" [(ngModel)]="minVal" class="se-form-control col-md-9 commonWidth"  appRequiredElementValidator #minLimit="ngModel" [fieldName]="'Min Limit'" (change)="validateForm()">
            <span>{{unit}}</span>
            <div class="d-block brand-error se-fs-12" *ngIf="!minLimit.errors.requiredElementValidator.isValid && (minLimit.dirty || minLimit.touched)">
              {{ minLimit.errors.requiredElementValidator.error }}
            </div>
          </div>
          <!-- max res value -->
          <div class="form-ele col-md-12">
            <label for="maxVal" class="se-label col-md-3"> {{labels.limit| translate}} ({{labels.max| translate}})<span>*</span></label>
            <input id="maxVal" type="number" autocomplete="off" [(ngModel)]="maxVal" class="se-form-control col-md-9 commonWidth"  appRequiredElementValidator #maxLimit="ngModel" [fieldName]="'Max Limit'" (change)="validateForm()">
            <span>{{unit}}</span>
            <div class="d-block brand-error se-fs-12" *ngIf="!maxLimit.errors.requiredElementValidator.isValid && (maxLimit.dirty || maxLimit.touched)">
              {{ maxLimit.errors.requiredElementValidator.error }}
            </div>
          </div>
        </div>
        <div *ngIf="showAlarmWhen" class="mb-3">
          <div class="form-ele col-md-12">
            <label for="alarmWhen" class="se-label col-md-3"> {{labels.alarmWhen| translate}}<span>*</span></label>
            <select id="drpAlarmWhen" aria-label="drpAlarmWhen" class="se-form-control col-md-8 commonWidth" [(ngModel)]="selectedalarmWhen">
              <option *ngFor="let item of alarmWhenList; let i = index" [ngValue]="item.value">{{item.desc|translate}}</option>
            </select>
            <span>{{unit}}</span>
          </div>
        </div>
        <!-- notified to email -->
        <div class="form-ele col-md-12">
          <label for="txtNotifiedTo" class="se-label col-md-3">{{labels.alarmReceiverEmail| translate}}<span>*</span></label>
          <input readonly id="txtNotifiedTo" autocomplete="off" type="text" [(ngModel)]="defaultLoggedInEmail" #txtNotify
                 class="input-content-txt se-form-control col-md-8 commonWidth" appMultiEmailValidator #NotifiedTomail="ngModel" (keyup)="validateForm()">
          <button title="Add Email" class="se-button button-primary" type="button" (click)="showInputboxs()">+</button>
        </div>
        <div class="form-ele col-md-12 email-scroll-box " *ngIf="displayInputBoxs">
          <div>
            <ng-container *ngFor="let email of emialIds; let idx = index; trackBy: trackByIndex">
            <label for="txtNotifiedTo1" class="se-label col-md-3"><span></span></label>
            
              <input
                id="txtNotifiedTo1"
                type="text"
                [(ngModel)]="emialIds[idx]"
                class="input-content-txt se-form-control col-md-8  inputemailid"
                appMultiEmailValidator
                placeholder="Enter email"
                
              >
              <button type="button"  class="se-button ml-1 padding-left removeEmailbtn" (click)="removeEmail(idx)">-</button>
            
            </ng-container>
          </div>
        </div>
        
        
        <!-- severity -->
        <div class="form-ele col-md-12">
          <label class="se-label col-md-3"> {{labels.severity | translate}}<span>*</span></label>
          <label class="radio-holder col-md-2">
            <span>{{labels.high|translate}}</span>
            <input class="radio" type="radio" name="severity" [value]='1' [(ngModel)]="severity" (click)="ApplyToSelectionChange()"
                   (keypress)="ApplyToSelectionChange()"
                   (keydown)="ApplyToSelectionChange()"
                   (keyup)="ApplyToSelectionChange()">
            <span class="checkmark" data-color="primary"></span>
          </label>
          <label class="radio-holder col-md-2">
            <span>{{labels.low|translate}}</span>
            <input type="radio" name="severity" [value]='2' [(ngModel)]="severity" class="radio"
                   (keypress)="ApplyToSelectionChange()"
                   (keydown)="ApplyToSelectionChange()"
                   (keyup)="ApplyToSelectionChange()"
                   (click)="ApplyToSelectionChange()">
            <span class="checkmark" data-color="primary"></span>
          </label>
        </div>

        <div class="form-ele col-md-12">
          <label for="delay" class="se-label col-md-3"> {{labels.delay| translate}}</label>
          <div class="delay">
            <button type="button" class="se-button mr-0"(click)="decreaseDelay()">-</button>
            <input readonly id="delayVal" type="number" autocomplete="off" [(ngModel)]="delay" aria-label="delayLimit"
                  class="se-form-control col-md-1 delayInput" #delayLimit="ngModel" [fieldName]="'Delay'" (change)="validateForm()">
            <button type="button" class="se-button button-primary" (click)="increaseDelay()">+</button>
            <span for="min" class="delayMin"> {{labels.minute| translate}}</span>
            <img src="assets/info.svg" class="icon-action info-icon delayInfoIcon" [title]="(labels.delayInfo | translate)"  alt="info" height="15" width="15"/>
          </div>
                   
          <div class="d-block brand-error se-fs-12" *ngIf=" (delayLimit.dirty || delayLimit.touched) ">
            {{ delayLimitNonPostiveError }}
          </div>
          
        </div>

        <div class="form-ele col-md-12" *ngIf="isEdit">
          <label class="se-label col-md-3">{{labels.tableDataDeviceActive|translate}}</label>
          <div class="se-form-control col-md-3 borderNone">
            <label class="se-block-action switch ">
              <input type="checkbox" [(ngModel)]="isAlarmActive" class="alarmrule-block-check" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="se-dialog-footer">
          <button class="se-button" (click)="closeModal()">{{labels.cancel | translate}}</button>
          <button class="se-button button-primary" (click)="SaveRule(txtNotify,txtAlarmName)" [disabled]="formInvalid" [ngClass]="{ 'disabled-cls': formInvalid }">{{labels.saveAndApp | translate}}</button>

        </div>
      </div>
    </div>
  </div>
</div>
